import {CountryEnum} from "@/modules/base/enums";

export type TeamNamePatternType = {
  level: number,
  longPattern: string,
  shortPattern: string,
};

export const Abbreviations: { [key in CountryEnum]?: string[] } = {
  [CountryEnum.DE]: ['1.FC', 'FC', 'TSG', 'SC', 'FSV', 'BSC', 'VfL', 'SV', 'SpVgg', 'SSV', 'SG', 'TSV', 'MSV', 'BSV', 'BFC', 'AK', 'SVG', 'VfR', 'SSV'],
  [CountryEnum.GB]: ['FC', 'AFC'],
  [CountryEnum.IT]: ['AC', 'US', 'FC', 'SSC', 'CFC'],
  [CountryEnum.ES]: ['FC', 'UD', 'RCD', 'CA', 'CD', 'SD'],
  [CountryEnum.FR]: ['FC', 'RC', 'AS', 'OGC', 'HSC', 'SCO', 'AJ', 'AC', 'FCO', 'AF'],
};

export const Additions: { [key in CountryEnum]?: string[] } = {
  [CountryEnum.DE]: ['Union', 'Borussia', 'Eintracht', 'Werner', 'Fortuna', 'Arminia', 'Hansa', 'Dynamo', 'Viktoria', 'Rot-Weiss', 'Teutonia', 'Atlas', 'Blau-Weiss', 'Kickers', 'Lokomotive', 'Germania', 'Tennis', 'Alemannia'],
  [CountryEnum.GB]: ['City', 'United', 'Town', 'Rangers', 'Rovers', 'Athletic', 'Wanderers', 'Country', 'Hotspur', 'Forest'],
  [CountryEnum.IT]: ['Inter', 'Juventus', 'Atalanta', 'Lazio', 'Udinese', 'Spezia', 'Hellas', 'Sampdoria', 'Calcio', 'Club'],
  [CountryEnum.ES]: ['Real', 'Atletico', 'Betis', 'Celta', 'Espanyol', 'Royo', 'Deportivo', 'Sporting', 'Racing'],
  [CountryEnum.FR]: ['Stade', 'Saint-Germain', 'Olympique', 'Racing', 'Saint', 'Girondins', 'Sonchaux'],
};

export const TeamNames: { [key in CountryEnum]?: TeamNamePatternType[] } = {
  [CountryEnum.DE]: [
    {level: 8, longPattern: '{addition} {city}', shortPattern: '{abbr}{cityFirst}'},
    {level: 8, longPattern: '{abbr} {addition} {city}', shortPattern: '{abbr}{cityFirst}'},
    {level: 3, longPattern: '{abbr} {city} {year2}', shortPattern: '{cityFirst}{year2}'},
    {level: 3, longPattern: '{abbr} {city} {year4}', shortPattern: '{cityFirst}{year2}'},
    {level: 3, longPattern: '{city} {year2}', shortPattern: '{cityFirst}{year2}'},
    {level: 3, longPattern: '{city} {year4}', shortPattern: '{cityFirst}{year2}'},
    {level: 3, longPattern: '{abbr} {city} {year4}', shortPattern: '{cityFirst}{year2}'},
    {level: 3, longPattern: '{abbr} {year4} {city}', shortPattern: '{cityFirst}{year4}'},
    {level: 2, longPattern: '{city}er {year4}', shortPattern: '{cityFirst}{year4}'},
    {level: 2, longPattern: '{city}er {year2}', shortPattern: '{cityFirst}{year2}'},
    {level: 2, longPattern: '{city}er {abbr}', shortPattern: '{cityFirst}{abbr}'},
  ],
  [CountryEnum.GB]: [
    {level: 5, longPattern: '{city} {addition}', shortPattern: '{cityFirst}{abbr}'},
    {level: 5, longPattern: '{city} {addition} {abbr}', shortPattern: '{cityFirst}{abbr}'},
    {level: 5, longPattern: '{abbr} {city}', shortPattern: '{abbr}{cityFirst}'},
    {level: 1, longPattern: '{city} {year2}', shortPattern: '{cityFirst}{year2}'},
    {level: 1, longPattern: '{city} {year4}', shortPattern: '{cityFirst}{year2}'},
  ],
  [CountryEnum.IT]: [
    {level: 5, longPattern: '{addition} {city}', shortPattern: '{abbr}{cityFirst}'},
    {level: 5, longPattern: '{city} {addition}', shortPattern: '{abbr}{cityFirst}'},
    {level: 5, longPattern: '{abbr} {addition} {city}', shortPattern: '{abbr}{cityFirst}'},
    {level: 3, longPattern: '{abbr} {city} {year2}', shortPattern: '{cityFirst}{year2}'},
    {level: 3, longPattern: '{abbr} {city} {year4}', shortPattern: '{cityFirst}{year2}'},
    {level: 3, longPattern: '{city} {year2}', shortPattern: '{cityFirst}{year2}'},
    {level: 3, longPattern: '{city} {year4}', shortPattern: '{cityFirst}{year2}'},
    {level: 3, longPattern: '{abbr} {city} {year4}', shortPattern: '{cityFirst}{year2}'},
    {level: 3, longPattern: '{abbr} {year4} {city}', shortPattern: '{cityFirst}{year4}'},
  ],
  [CountryEnum.ES]: [
    {level: 7, longPattern: '{addition} {city}', shortPattern: '{cityFirst}{abbr}'},
    {level: 7, longPattern: '{abbr} {city}', shortPattern: '{abbr}{cityFirst}'},
    {level: 7, longPattern: '{abbr} {addition} {city}', shortPattern: '{abbr}{cityFirst}'},
    {level: 1, longPattern: '{city} {year2}', shortPattern: '{cityFirst}{year2}'},
    {level: 1, longPattern: '{city} {year4}', shortPattern: '{cityFirst}{year2}'},
    {level: 1, longPattern: '{abbr} {city} {year2}', shortPattern: '{abbr}{year2}'},
    {level: 1, longPattern: '{abbr} {city} {year4}', shortPattern: '{abbr}{year2}'},
  ],
  [CountryEnum.FR]: [
    {level: 6, longPattern: '{addition} {city}', shortPattern: '{cityFirst}{abbr}'},
    {level: 6, longPattern: '{city} {addition}', shortPattern: '{cityFirst}{abbr}'},
    {level: 6, longPattern: '{abbr} {city}', shortPattern: '{abbr}{cityFirst}'},
    {level: 6, longPattern: '{abbr} {addition} {city}', shortPattern: '{abbr}{cityFirst}'},
    {level: 2, longPattern: '{city} {year2}', shortPattern: '{cityFirst}{year2}'},
    {level: 2, longPattern: '{city} {year4}', shortPattern: '{cityFirst}{year2}'},
    {level: 2, longPattern: '{abbr} {city} {year2}', shortPattern: '{abbr}{year2}'},
    {level: 2, longPattern: '{abbr} {city} {year4}', shortPattern: '{abbr}{year2}'},
  ],
};
